import React from 'react';
import { Carousel, message } from 'antd';
import axios from 'axios';
import '../css/Carousel.scss'
import { visitClick } from '../apis/App';

const key = 'updatable';

const renderTitle = (item, isMultiPlatform) => (
  <h3 style={isMultiPlatform ? { marginBottom: item.marginBottom || '', ...item?.textStyle || {} } : { ...item?.textStyle || {} }}>
    {item.text.map((row, index) => {
      const textColor = row.customColor ?? (item.darkText && !isMultiPlatform ? '#000000' : '#121213');
      const colorTextColor = row.customColorText ?? '#015AFF';
      return (
        <React.Fragment key={index}>
          <span className='colorText' style={{ color: row.opposite ? textColor : colorTextColor }}>
            {row.opposite ? row.text : row.colorText}
          </span>
          <span className='Text' style={{ color: row.opposite ? colorTextColor : textColor }}>
            {row.opposite ? row.colorText : row.text}
          </span>
          {row.br && <br />}
        </React.Fragment>
      );
    })}
  </h3>
);

export default React.memo((props) => {
  const { data } = props
  const [phone,setPhone] = React.useState('');
  const [de,setDe] = React.useState(false);
  const submit = async() => {
    let data = {
      phone: phone,
      type: 4
    }
    if(phone.length < 11 || phone == ''|| !(/^1[3456789]\d{9}$/.test(phone))){
      message.warning('请输入正确的手机号码')
      return
    }
    if(de) return
    setDe(true);
    message.loading({ content: '提交中...', key });
    const Result = await axios.post('/api/Official/saveOfficialFrom',data);
    if(Result.code !== 200){
      message.error( Result.message || '提交失败');
      return
    }
    message.success({ content: '提交成功!', key, duration: 2 });
    setDe(false);
  }

  // 官网访问点击
  const onVisitClick = async (data, onSuccess) => {
    let hide = null
    if (onSuccess !== 0) {
      hide = message.loading('', 0)
    }
    const parameter = {
      ...data
    }
    const res = await visitClick(parameter)
    hide && hide();
    if (res.code !== 200) {
      // message.error('请重试！')
      return;
    }
    onSuccess && onSuccess();
  }

  const handlePhoneChange = (e) => {
    if (e.target.value.length > 11) e.target.value = e.target.value.slice(0, 11);
    setPhone(e.target.value);
  }

  const handleDemoClick = (isMultiPlatform) => {
    if (!isMultiPlatform) {
      submit();
      console.log(window.location.pathname.split('/'));
    }
    const page = window.location.pathname.split('/')[1];
    onVisitClick({
      type: 3,
      domain: 'www.qolai.cn',
      page: page ? page : 'home',
      button: isMultiPlatform ? 'registerUse' : page == 'seft' ? 'free_use' : ''
    }, 0);
    submit();
  }

  const renderDemoButton = (isMultiPlatform) => (
    <div className='Carousel-button d-flex animated fadeInRight'>
      <input type="number" onChange={handlePhoneChange} placeholder='请输入您的手机号' />
      <div onClick={() => handleDemoClick(isMultiPlatform)} className='button'>获取演示案例</div>
    </div>
  );

  return (
    <div className='carousel-view' style={{ height: '680px', overflow:'hidden' }}>
      <Carousel autoplay={true} autoplaySpeed={3000} className="carousel-view-active">
        {data.map((item, index) => {
          const isMultiPlatform = item.type === 'multi_platform';
          const isFranchise = item.type === 'apply-franchise';
          return (
            <div className={`Carousel-index${!isMultiPlatform && !isFranchise && item.darkText ? ' dark-text' : ''}`} key={index}>
              <img src={item.carouselImage} style={{ width: '100%', height: '100%' }} alt="" />
              <div
                className={`Carousel-content${isFranchise ? ' franchise' : ''}`}
                style={!isMultiPlatform ? { maxWidth: item.maxWidth ? item.maxWidth : '1440px' } : undefined}
              >
                {isFranchise ? (
                  <>
                    <img className='Carousel-img' src={item.desc} style={{ width: '100%', height: '100%' }} alt="" />
                    <div className='apply-franchise' onClick={() => window.open(`https://laiyuntai.com/?type=franchise`)}>申请加盟</div>
                  </>
                ) : isMultiPlatform ? (
                  <div className='Carousel-douyin'>
                    <div className='animated fadeInUp'>
                      {renderTitle(item, true)}
                      {item.icons && <img src={item.icons} style={{ width: '1440px', height: '180px' }} />}
                      {item.textTwo && (
                        <div className='textTwo'>
                          {item.textTwo.map((row, col) => (
                            <div key={col}>
                              <span style={{ color: '#121213' }}>{row.text}</span>
                              <span style={{ color: '#015AFF' }}>{row.colorText}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {renderDemoButton(true)}
                  </div>
                ) : (
                  <div className='Carousel-item' style={{ marginTop: item.marginTop ? item.marginTop : '' }}>
                    <div className='animated fadeInRight'>
                      {renderTitle(item, false)}
                      {item.desc && <span className='desc' style={{ color: item.customDescTextColor || '#121213' }}>{item.desc}</span>}
                      {item.desc && item.descTwo ? <br /> : null}
                      {item.descTwo && <span className='desc'>{item.descTwo}</span>}
                      {item.scenes && item.scenes.length !== 0 && (
                        <div>
                          <div className='scenes' style={{ backgroundColor: item.background && item.background }}>
                            {item.scenes.map((row, col) => (
                              <React.Fragment key={col}>
                                {row.icon && <img src={row.icon} />}
                                <span style={{ fontWeight: item.fontWeight && item.fontWeight }}>{row.text}</span>
                              </React.Fragment>
                            ))}
                          </div>
                        </div>
                      )}
                      {item.characteristic && item.characteristic.length !== 0 && (
                        <div className='characteristic-div'>
                          {item.characteristic.map((row, col) => (
                            <div className='characteristic' key={col}>
                              <span>{row.text}</span>
                            </div>
                          ))}
                        </div>
                      )}
                      {item.iconscenes && item.iconscenes.length !== 0 && (
                        <div className='iconscenes-div'>
                          {item.iconscenes.map((row, col) => (
                            <div className={row.gray ? 'iconscenes-gray' : 'iconscenes'} style={{ width: row.width ? row.width : '', ...(item.iconCardWhite ? { background: '#FFFFFF' } : {}) }} key={col}>
                              <img src={row.icon} />
                              <span style={item.iconCardWhite ? { color: '#000000' } : undefined}>{row.text}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {renderDemoButton(false)}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </Carousel>
    </div>
  );
})
